import Endpoint from "../../services/api/endpoint";
import { IContractor } from "../../utils/types/models";
import { createEntityReducer } from "./entityReducer";

export default createEntityReducer<IContractor>(Endpoint.Contractors, Endpoint.ContractorsList);